
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/award-winners",
      function () {
        return require("private-next-pages/world/award-winners.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/award-winners"])
      });
    }
  